// 複数ヒットのダメージ分布（たたみ込み）とリスト→頻度マップ化

export function tatamikomi(dictList: { [name: number]: number }[]): { [name: number]: number } {
  if (dictList.length === 0) return {};
  if (dictList.length === 1) return dictList[0];

  // dictList を破壊的に畳み込むため、再利用する場合は事前にコピーする
  const [m1, m2, newD] = [dictList.shift(), dictList.shift(), {} as { [name: number]: number }];
  if (m1 && m2) {
    Object.keys(m1).forEach((k1) => {
      Object.keys(m2).forEach((k2) => {
        const [m1i, m2i] = [parseInt(k1), parseInt(k2)];
        if (!Object.hasOwn(newD, m1i + m2i)) newD[m1i + m2i] = 0;
        newD[m1i + m2i] += m1[m1i] * m2[m2i];
      });
    });
    dictList.unshift(newD);
    return tatamikomi(dictList);
  }
  return dictList[0] || {};
}

export function listToMapper(numberList: number[]): { [name: number]: number }[] {
  const temp: { [name: number]: number } = {};
  numberList.forEach((w: number) => {
    if (!Object.hasOwn(temp, w)) temp[w] = 0;
    temp[w] += 1;
  });
  return [temp];
}

// 複数ヒット時の確率（%）を計算（1発時はcalcRate相当）
export function calcRateMultiHit(
  hp: number,
  damageDistribution: { [damage: number]: number },
  hitCount: number
): number {
  if (hitCount === 1) {
    return calcRate(hp, damageDistribution);
  }
  // 1発の分布を配列化し、n発の組み合わせで総ダメージ分布を作る
  const damageValues: number[] = [];
  Object.entries(damageDistribution).forEach(([damage, count]) => {
    const damageNum = parseInt(damage);
    for (let i = 0; i < count; i++) damageValues.push(damageNum);
  });
  const totalPatterns = Math.pow(damageValues.length, hitCount);
  let successPatterns = 0;
  const maxPossibleDamage = Math.max(...damageValues) * hitCount;
  // dp[攻撃回数][合計ダメージ] = 組み合わせ数（全列挙を避ける）
  const dp: number[][] = Array(hitCount + 1)
    .fill(null)
    .map(() => Array(maxPossibleDamage + 1).fill(0));
  dp[0][0] = 1;
  for (let attack = 1; attack <= hitCount; attack++) {
    for (let totalDamage = 0; totalDamage <= maxPossibleDamage; totalDamage++) {
      for (const damage of damageValues) {
        if (totalDamage >= damage && dp[attack - 1][totalDamage - damage] > 0) {
          dp[attack][totalDamage] += dp[attack - 1][totalDamage - damage];
        }
      }
    }
  }
  for (let damage = hp; damage <= maxPossibleDamage; damage++) {
    successPatterns += dp[hitCount][damage];
  }
  const rate = (successPatterns / totalPatterns) * 100;
  return parseFloat(rate.toFixed(1));
}

// 1発分布から倒せる確率（%）を計算
export function calcRate(
  hp: number,
  retTatamikomi: {
    [name: number]: number;
  }
): number {
  const sumPatternNumber = Object.values(retTatamikomi).reduce((s, e) => s + e, 0);
  const okPattern = Object.keys(retTatamikomi).filter((d) => parseInt(d) >= hp);
  let okPatternNumber = 0;
  Object.keys(retTatamikomi).forEach((d) => {
    if (okPattern.includes(d)) okPatternNumber += retTatamikomi[parseInt(d)];
  });
  const rate = okPatternNumber / sumPatternNumber;
  return parseFloat((rate * 100).toFixed(1));
}

// 何発で確定/乱数になるかを判定
export function calcKakuteiRansuu(
  hp: number,
  minDamage: number,
  maxDamage: number,
  n: number
): { s: string; n: number } {
  // 収束しないケースに備えて上限を設ける
  if (n > 1000) return { s: '乱数', n };
  // ダメージが発生しない場合は乱数扱いで打ち切る
  if (maxDamage === 0) return { s: '乱数', n: 999 };
  if (n * minDamage >= hp) return { s: '確定', n };
  if (n * minDamage < hp && n * maxDamage >= hp) return { s: '乱数', n };
  return calcKakuteiRansuu(hp, minDamage, maxDamage, n + 1);
}
